import CONST from "./Constant";

const INITIAL_STATE = {
    config: {},
    mode: null,
    broadcast: "",
    modal: { open: false, component: null, title: '', size: 'md', fullScreen: false, maxWidth: 'md', maxHeight: 'md', },
    menu: { open: false, component: null, anchorEl: null, activeMenu: 'dashboard' },
    leftDrawer: { open: false, title: '', width: 240 },
    rightDrawer: { open: false, component: null, title: '', width: 500 },
    blockUI: { open: false, message: '' },
    appBarHeight: '80px',
    notifications: [],
    permissions: [],
    theme: {},
    consent: null,
    error: [],
    message: [],
};

const Reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CONST.INITIALIZE:
            return {
                ...state,
                mode: action.payload,
                activeMenu: 'dashboard',
            };
        case CONST.SET_CONFIG:
            return {
                ...state,
                config: {
                    ...state.config,
                    ...action.payload
                },
            };
        case CONST.SET_MODE:
            return {
                ...state,
                mode: action.payload,
            };
        case CONST.FETCH_CONFIG_SUCCESS:
            return {
                ...state,
                config: action.payload.data?.config,
                settings: action.payload.data?.settings,
                mode: action.payload.data?.mode,
                permissions: action.payload.data?.permissions,
                notifications: action.payload.data?.notifications,
                theme: action.payload.data?.theme,
                error: [],
                message: ["Config loaded successfully"],
            };
        case CONST.FETCH_CONFIG_FAILED:
            return {
                ...state,
                error: action.payload.data.errors,
                message: action.payload.data.message,
                code: action.payload.status,
            };
        case CONST.SET_APPBAR_HEIGHT:
            return {
                ...state,
                appBarHeight: action.payload,
                message: ["Appbar height set successfully"],
            }
        case CONST.SET_ACTIVE_MENU:
            return {
                ...state,
                menu: { ...state.menu, activeMenu: action.payload }
            }
        case CONST.SET_MODAL:
            return {
                ...state,
                modal: {
                    ...state.modal,
                    ...action.payload,
                    size: action.payload.size || 'sm',
                    fullScreen: action.payload.fullScreen || false,
                }
            }
        case CONST.SET_MENU:
            return {
                ...state,
                menu: {
                    ...state.menu,
                    ...action.payload,
                }
            }
        case CONST.SET_LEFT_DRAWER:
            return {
                ...state,
                leftDrawer: { ...state.leftDrawer, ...action.payload }
            }
        case CONST.SET_RIGHT_DRAWER:
            return {
                ...state,
                rightDrawer: { ...state.rightDrawer, ...action.payload }
            }
        case CONST.BLOCKUI_STATE:
            return {
                ...state,
                blockUI: { ...state.blockUI, ...action.payload }
            }
        case CONST.PREVIEW_THEME:
            return {
                ...state,
                temp: { ...state.theme },
                theme: action.payload
            }
        case CONST.RESTORE_THEME:
            return {
                ...state,
                theme: { ...state.temp },
                temp: {}
            }
        case CONST.SET_THEME:
            return {
                ...state,
                theme: action.payload
            }
        case CONST.SET_CONSENT:
            return {
                ...state,
                consent: action.payload,
            };
        default:
            return state;
    }
};

export default Reducer;
